import { useContext, useMemo } from 'react';
import { format } from 'date-fns';

import WorkUsers from '@atom/components/common/workUsers/WorkUsers';
import fonts from '@atom/styles/fonts';
import { WorkOrder, WorkOrderUserGroup } from '@atom/types/work';
import { rollUpTaskUsers } from '@atom/utilities/userUtilities';
import { getWorkOrderStatusCalendarColor } from '@atom/utilities/workOrderStatusUtilities';

import WorkOrdersContext from '../WorkOrdersContext';

import WeekViewEventTitle from './WeekViewEventTitle';

const styles = {
  event: {
    borderRadius: '0.375rem',
    fontSize: fonts.sm,
    marginBottom: '0.5rem',
    padding: '0.25rem 0.5rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  },
  avatars: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  eventTime: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};

interface Props {
  workOrder: WorkOrder;
}

const WeekViewEvent = ({ workOrder }: Props) => {
  const { input, setInput } = useContext(WorkOrdersContext);
  const backgroundColor = getWorkOrderStatusCalendarColor(workOrder.statusId);

  const userGroups = useMemo(() => {
    return workOrder.tasks.reduce(
      (acc: WorkOrderUserGroup[], task) => [...acc, ...task.userGroups],
      [],
    );
  }, [workOrder]);

  const timeDisplay = useMemo(() => {
    return workOrder.plannedStartDate && workOrder.dueDate ? (
      <div>
        {format(workOrder.plannedStartDate, 'hh:mm a')} -{' '}
        {format(workOrder.dueDate, 'hh:mm a')}
      </div>
    ) : null;
  }, [workOrder]);

  return (
    <div
      style={{
        ...styles.event,
        background: backgroundColor,
      }}
      onClick={() => setInput({ ...input, workOrderId: workOrder.id })}
    >
      <div style={styles.eventTime}>{timeDisplay}</div>
      <div>
        <WeekViewEventTitle workOrder={workOrder} />
      </div>
      <div style={styles.avatars}>
        <WorkUsers
          users={rollUpTaskUsers(workOrder?.tasks as any)}
          userGroups={userGroups}
          avatarSize={18}
          useNoAssigneesIcon
          alignRight
        />
      </div>
    </div>
  );
};

export default WeekViewEvent;
